// Module
var code = "<svg viewBox=\"0 0 515.556 515.556\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <path d=\"M96.667 32.222v96.667h64.444V96.667h290v322.222h-290v-32.222H96.667v96.667h418.889V32.222z\"/>\r\n  <path d=\"M157.209 331.663l45.564 45.564 119.449-119.449-119.448-119.449-45.564 45.564 41.662 41.662H0V290h198.872z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;